import { Value } from "@stringtale/react"
import styled from "@emotion/styled"
import { useRouter } from "app/core/hooks/useRouter"
import {
  DARK_BLUE_COLOR,
  LIGHT_GREEN_COLOR,
  LIGHT_GREY_COLOR,
  ORANGE_COLOR,
  PX18,
  PX24,
} from "theme/consts"
import Button from "ui/Button"
import Link from "next/link"

const Body = styled.div`
  background-color: ${LIGHT_GREEN_COLOR};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const ErrorContainer = styled.div`
  padding: 40px;
  border: 1px solid ${LIGHT_GREY_COLOR};
  border-radius: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 25px;
  text-align: left;
  max-width: 50%;
  align-items: center;
  box-sizing: border-box;
  margin: 60px;
  @media (max-width: 768px) {
    max-width: 80%;
    padding: 20px;
  }
`

const ErrorTitle = styled.h2`
  font-size: ${PX24};
  font-weight: 900;
  color: ${DARK_BLUE_COLOR};
`

const ErrorMessage = styled.span`
  font-size: ${PX18};
  color: ${DARK_BLUE_COLOR};
`

const ErrorButton = styled(Button)`
  background-color: ${ORANGE_COLOR};
  border-radius: 50px;
  color: white;
  height: 50px;
  width: 200px;
`

const ErrorCode = styled.pre`
  margin-bottom: 40px;
`

export const RequestFailed = function ({
  code,
  message,
}: {
  code: string | number
  message: string
}) {
  return (
    <>
      <Body>
        <ErrorContainer>
          <ErrorTitle>
            <Value name="apps.web.src.errors.requestfailed.title">
              Er is iets misgegaan
            </Value>
          </ErrorTitle>
          <ErrorMessage>
            <Value
              name="apps.web.src.errors.requestfailed.message"
              format={{
                li: (c) => <li>{c}</li>,
                ul: (c) => <ul>{c}</ul>,
              }}
            >{`
              Je moet het volgende doen:
              <ul>
                 <li>
                  Deel onderstaande informatie met de systeembeheerder
                </li>
                 <li>
                  Voeg een omschrijving toe van de actie of handeling die je
                  probeerde uit te voeren en waarbij het mis ging
                </li>
              </ul>
              `}</Value>
          </ErrorMessage>
          <ErrorCode>
            {`
            Foutcode: ${code}
            Foutmelding: ${message}
          `}
          </ErrorCode>
          <ErrorButton
            as={Link}
            // @ts-ignore
            href="/"
          >
            <Value name="apps.web.src.errors.requestfailed.terug_naar_home">
              Terug naar home
            </Value>
          </ErrorButton>
        </ErrorContainer>
      </Body>
    </>
  )
}
